import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessPunchCardUserRewardManagerHandler {
 	url: any;
 	token: any;
  	rewardId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getReward(params){	
	  	this.url = this.globals.dataUrl + 'businessPunchCardUserReward/' + params.rewardId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res);
		    });   
    	})
  	}

	
	redeemReward(params){
	    this.url = this.globals.dataUrl + 'businessPunchCardUserReward/' + params.RewardId;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})           
	}
}



// WEBPACK FOOTER //
// ./src/providers/business-punch-card-user-reward-handler.ts